module.exports = new __parcel__URL__("target-single.a1a07a4f.svg").toString();